module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box box-primary"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [(_vm.pdf) ? _c('div', [_c('embed', {
    attrs: {
      "type": "application/pdf",
      "src": _vm.pdf,
      "width": "100%",
      "height": _vm.heigthPdf
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Ano")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtros.ano),
      expression: "filtros.ano"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "ano"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.filtros, "ano", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "2026"
    }
  }, [_vm._v("2026")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2025"
    }
  }, [_vm._v("2025")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2024"
    }
  }, [_vm._v("2024")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2023"
    }
  }, [_vm._v("2023")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2022"
    }
  }, [_vm._v("2022")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2021"
    }
  }, [_vm._v("2021")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2020"
    }
  }, [_vm._v("2020")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2019"
    }
  }, [_vm._v("2019")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Mês")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtros.mes),
      expression: "filtros.mes"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "mes"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.filtros, "mes", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("-- TODOS --")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "01"
    }
  }, [_vm._v("Janeiro")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "02"
    }
  }, [_vm._v("Fevereiro")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "03"
    }
  }, [_vm._v("Março")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "04"
    }
  }, [_vm._v("Abril")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "05"
    }
  }, [_vm._v("Maio")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "06"
    }
  }, [_vm._v("Junho")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "07"
    }
  }, [_vm._v("Julho")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "08"
    }
  }, [_vm._v("Agosto")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "09"
    }
  }, [_vm._v("Setembro")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "10"
    }
  }, [_vm._v("Outubro")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "11"
    }
  }, [_vm._v("Novembro")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "12"
    }
  }, [_vm._v("Dezembro")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Unidade")]), _vm._v(" "), _c('select-unidade', {
    on: {
      "setUnidadeSelecionada": function (unidadeSelecionada) {
        _vm.setUnidadeSelecionada(unidadeSelecionada)
      }
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-2 form-group"
  }, [_c('label', [_vm._v(" ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary form-control",
    attrs: {
      "data-toggle": "tooltip",
      "title": "Buscar"
    },
    on: {
      "click": function($event) {
        _vm.getDataTable()
      }
    }
  }, [_c('span', {
    staticClass: "fa fa-search"
  }), _vm._v(" Buscar\n              ")])])]), _vm._v(" "), (!_vm.isEmpty(_vm.dataTable) && !_vm.pdf) ? _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-top": "15px"
    }
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "table-responsive form-group"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped"
  }, [_vm._m(1), _vm._v(" "), _c('tbody', _vm._l((_vm.dataTable), function(item) {
    return _c('tr', {
      key: item.id
    }, [_c('td', [_vm._v(_vm._s(item.ano))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.mes))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.unidade))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.subgrupo))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.quantidade_disponivel))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.quantidade_agendada))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.quantidade_realizada))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.oferta))])])
  }))])])])]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), (!_vm.isEmpty(_vm.dataTable)) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-offset-10 col-sm-2 text-right"
  }, [_c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.pdf),
      expression: "!pdf"
    }],
    staticClass: "btn btn-info pdf",
    attrs: {
      "disabled": _vm.finalizado
    },
    on: {
      "click": function($event) {
        if ($event.target !== $event.currentTarget) { return null; }
        $event.preventDefault();
        return _vm.getPDF($event)
      }
    }
  }, [_c('span', {
    staticClass: "fa fa-file-pdf-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" PDF\n                ")])])]) : _c('div', [_vm._v("Nenhum registro encontrado.")])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_c('b', [_vm._v("Oferta Anual de Subgrupos")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Ano")]), _vm._v(" "), _c('th', [_vm._v("Mês")]), _vm._v(" "), _c('th', [_vm._v("Unidade")]), _vm._v(" "), _c('th', [_vm._v("Subgrupo")]), _vm._v(" "), _c('th', [_vm._v("Quantidade Disponível")]), _vm._v(" "), _c('th', [_vm._v("Quantidade Agendada")]), _vm._v(" "), _c('th', [_vm._v("Quantidade Realizada")]), _vm._v(" "), _c('th', [_vm._v("Total da Oferta")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-985470a8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/administracao/relatorios/ofertas_subgrupo_anual/index.vue
// module id = 883
// module chunks = 0